var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"first-line"},[_c('ReturnButton',{staticClass:"return-button"})],1),_c('ResultTitle',{staticClass:"result-title"}),_c('DataTable',{staticClass:"data-table"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }